import { useTheme } from '../context/theme';
import { Card, Avatar } from './ui';

function isOnline(u) {
  if (!u.last_active) return false;
  return (Date.now() - new Date(u.last_active).getTime()) < 5 * 60 * 1000;
}

export default function TeamWorkload({ users }) {
  const { theme, isDark } = useTheme();
  const sorted = (users || []).filter(u => u.active).sort((a, b) => isOnline(b) - isOnline(a));

  return (
    <Card>
      <div style={{ fontSize: 16, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", letterSpacing: '-0.01em', color: theme.text, marginBottom: 14 }}>Team</div>
      {sorted.map(u => (
        <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <div style={{ position: 'relative', flexShrink: 0 }}>
            <Avatar name={u.name} color={u.avatar_color} sz={28} />
            {isOnline(u) && <div style={{ position: 'absolute', bottom: -1, right: -1, width: 10, height: 10, borderRadius: '50%', background: '#4ADE80', border: `2px solid ${theme.bgCard}` }} />}
          </div>
          <span style={{ fontSize: 13, color: theme.text, flex: 1 }}>{u.name}</span>
          <span style={{ fontSize: 12, color: isOnline(u) ? theme.accent : theme.textSecondary }}>{isOnline(u) ? 'online' : u.role}</span>
        </div>
      ))}
    </Card>
  );
}
